/*
 * @Descripttion:
 * @Author: 老板说这个需求很简单
 * @Date: 2025-05-19 10:22:16
 * @LastEditTime: 2025-09-10 16:15:20
 * @LastEditors: sudo_rm_rf
 */

import { createPinia } from 'pinia';
import createPersistedState from 'pinia-plugin-persistedstate'; //引入pinia数据持久化插件
const pinia = createPinia();
pinia.use(createPersistedState);
import { initGetInfo, initLoadRouters } from '/@/store';
import { getCookie } from '/@/utils/cookie';

import App from './App.vue';
import router from './router';
import directive from './directive'; // directive
import registerCom from './registerCom'; //registerComponents

import ant from 'ant-design-vue';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

// import 'ant-design-vue/dist/antd.dark.less';
import '/@/assets/styles/views/app.less';
import '/@/assets/styles/ant/base.less';
// import '/@/utils/checkUpdate.ts';

// echarts 按需引入
// import echarts from '/@/utils/echarts';

import 'uno.css';
import i18n from './language';
// import './permission'; // permission control

import STable from '@surely-vue/table';
import '@surely-vue/table/dist/index.less';
import scanner from './utils/scanner';
// import 'es-drager/lib/style.css';
// import Drager from 'es-drager';

const app = createApp(App);
app.config.globalProperties.window = window;
// echarts 挂载到 Vue实例中
// 注意：app.config.globalProperties 和 app.provide('$echarts', echarts) 二选一即可
// app.config.globalProperties.$echarts = echarts; // vue3的挂载方式（一个用于注册能够被应用内所有组件实例访问到的全局属性的对象。）
// app.provide('$echarts', echarts);

// app.component('es-drager', Drager);
// 加载edit里面的拖拽组件

directive(app);
registerCom(app);
app.use(pinia).use(i18n).use(STable).use(ant).use(ElementPlus).use(scanner).use(router).mount('#app');
// const init = async () => {
//   if (getCookie('TOKEN')) {
//     await initGetInfo();
//     await initLoadRouters();
//     app.use(router).mount('#app');
//   } else {
//     app.use(router).mount('#app');
//   }
// };
// init();
